import { ComponentProps, useState } from "react"

import type { AnyFieldApi } from "@tanstack/react-form"

import { FormLabel } from "@/components/FormLabel"
import { FormInput } from "@/components/FormInput"
import { cn } from "@/lib/shadcn-utils"

import { VisibilityToggleButton } from "./VisibilityToggleButton"

interface PasswordFormInputProps extends ComponentProps<"input"> {
  field: AnyFieldApi
  label: string
}

export function PasswordFormField({
  field,
  label,
  className,
  ...props
}: PasswordFormInputProps) {
  const [isVisible, setIsVisible] = useState(false)

  return (
    <div className="tw-flex tw-flex-col tw-gap-1">
      <FormLabel field={field} label={label} className="tw-text-lg" />
      <div className="tw-relative">
        <FormInput
          field={field}
          type={isVisible ? "text" : "password"}
          className={cn(
            "tw-w-full tw-text-md tw-pl-3 tw-pr-10 tw-py-2",
            className,
          )}
          {...props}
        />
        <VisibilityToggleButton
          onVisibilityChange={setIsVisible}
          ariaLabelShow="Show password"
          ariaLabelHide="Hide password"
        />
      </div>
    </div>
  )
}
